import { GeographyCountry, GeographyRegion } from '@api/api/geographies';

export type DropdownItem =
  | {
      kind: 'region';
      region: GeographyRegion;
      expandable: boolean;
    }
  | {
      kind: 'country';
      country: GeographyCountry;
      indented: boolean;
      parentRegionCode?: string;
    };

export const getExpandedRegionCountryItems = (
  region: GeographyRegion,
  expandedRegions: Set<string>
): DropdownItem[] => {
  if (!expandedRegions.has(region.code)) {
    return [];
  }

  return region.countries.map(country => ({
    kind: 'country',
    country,
    indented: true,
    parentRegionCode: region.code,
  }));
};

export const buildItemKey = (item: DropdownItem) => {
  if (item.kind === 'region') {
    return `region:${item.region.code}`;
  }

  if (item.indented) {
    return `country:${item.parentRegionCode}:${item.country.code}:child`;
  }

  return `country:${item.country.code}:top`;
};
